// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4260":"0709abea","4766":"0709abea"}[chunkId] + ".chunk.css";
};